// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import userInfo from './config/config'
import less from 'less'
import './assets/font/iconfont.css'
import './assets/css/commen.less'
import globalVariable from '@/api/global_variable.js'
Vue.prototype.Global = globalVariable
Vue.use(less)
Vue.use(userInfo)
Vue.use(ElementUI)
Vue.config.productionTip = false
// 跨域安全策略：请求时携带 cookie
axios.defaults.withCredentials = true
Vue.prototype.axios = axios
Vue.config.devtools = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js